import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "category-page common-page"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = {
  class: "search"
};
const _hoisted_4 = {
  class: "search-form"
};
const _hoisted_5 = {
  class: "category-list"
};
import { reactive, ref } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import categoryDialog from "./components/category-dialog.vue";
import { deleteProductCategoryByIdApi, deleteProductCategoryBatchApi, getProductCategoryListByPageApi } from "@/service/modules/product";
export default /*@__PURE__*/_defineComponent({
  __name: 'category',
  setup(__props) {
    const categoryList = ref([]);
    const selectedCategories = ref([]);
    const categoryDialogVisible = ref(false);
    const categoryDialogType = ref("add");
    const categoryData = ref({});
    const page = reactive({
      page: 1,
      pageSize: 10,
      limit: 10
    });
    const total = ref(0);
    const form = reactive({
      categoryName: ""
    });
    getCategoryList();
    function handleClearCaseList() {
      form.categoryName = "";
      getCategoryList();
    }
    function restCaseList() {
      getCategoryList();
    }
    // 处理表格选择变化
    function handleSelectionChange(selection) {
      selectedCategories.value = selection;
    }
    // 批量删除
    function handleDeleteBatch() {
      if (selectedCategories.value.length === 0) {
        ElMessage.warning("请选择要删除的类目");
        return;
      }
      ElMessageBox.confirm(`确定删除选中的 ${selectedCategories.value.length} 个类目吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          const ids = selectedCategories.value.map(category => category.id);
          await deleteProductCategoryBatchApi(ids);
          ElMessage.success("批量删除成功");
          selectedCategories.value = [];
          getCategoryList();
        } catch (error) {
          console.error("批量删除失败", error);
          ElMessage.error("批量删除失败");
        }
      }).catch(() => {
        // 用户点击取消按钮时，不做任何操作
      });
    }
    async function getCategoryList() {
      try {
        let res = await getProductCategoryListByPageApi({
          ...page,
          ...form
        });
        console.log(res);
        res.data.records.forEach(item => {
          item.secondName = item.secondCategory.map(v => v.categoryName);
        });
        categoryList.value = res.data.records;
        total.value = Number(res.data.total);
      } catch {}
    }
    function handleDelete(id) {
      ElMessageBox.confirm("确定要删除该类目吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          await deleteProductCategoryByIdApi(id);
          ElMessage.success("删除成功");
          getCategoryList();
        } catch (error) {
          ElMessage.error("删除失败");
        }
      });
    }
    function handleUpdate(item) {
      categoryDialogType.value = "edit";
      categoryData.value = item;
      categoryDialogVisible.value = true;
    }
    function handleCategoryTableCurrentChange(val) {
      page.page = val;
      getCategoryList();
    }
    function handleOpenCategoryDialog() {
      categoryDialogType.value = "add";
      categoryData.value = {};
      categoryDialogVisible.value = true;
    }
    function handleCloseCategoryDialog() {
      categoryDialogType.value = "add";
      categoryData.value = {};
      categoryDialogVisible.value = false;
      getCategoryList();
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      const _component_proto_pagination = _resolveComponent("proto-pagination");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createTextVNode(" 类目管理 ")), _createVNode(_component_el_button, {
        onClick: handleOpenCategoryDialog,
        type: "primary",
        style: {
          "margin-left": "5px"
        }
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("新增")])),
        _: 1
      }), _createVNode(_component_el_button, {
        onClick: handleDeleteBatch,
        type: "danger",
        style: {
          "margin-left": "5px"
        },
        disabled: selectedCategories.value.length === 0
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("批量删除")])),
        _: 1
      }, 8, ["disabled"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
        inline: true,
        model: form,
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.categoryName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.categoryName = $event),
            style: {
              "width": "180px"
            },
            placeholder: "请输入类目名称",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = $event => handleClearCaseList())
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("重置")])),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: restCaseList
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("搜索")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_table, {
        data: categoryList.value,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        },
        onSelectionChange: handleSelectionChange
      }, {
        empty: _withCtx(() => _cache[10] || (_cache[10] = [_createElementVNode("div", {
          class: "table-empty"
        }, [_createElementVNode("img", {
          class: "no-data",
          src: _imports_0,
          alt: ""
        }), _createElementVNode("div", {
          class: "empty-text"
        }, "暂无数据")], -1)])),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }), _createVNode(_component_el_table_column, {
          label: "序号",
          width: "70"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1 + (page.page - 1) * page.limit), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "categoryName",
          label: "一级类目名称",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "secondName",
          label: "二级类目名称",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString(scope.row.secondName.join('、')), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => handleUpdate(scope.row)
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("编辑")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => handleDelete(scope.row.id)
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("删除")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(_component_proto_pagination, {
        page: page,
        total: total.value,
        onCurrentChange: handleCategoryTableCurrentChange
      }, null, 8, ["page", "total"])])]), _createVNode(categoryDialog, {
        "dialog-visible": categoryDialogVisible.value,
        "onUpdate:dialogVisible": _cache[2] || (_cache[2] = $event => categoryDialogVisible.value = $event),
        "dialog-type": categoryDialogType.value,
        "category-data": categoryData.value,
        onCloseDialog: handleCloseCategoryDialog
      }, null, 8, ["dialog-visible", "dialog-type", "category-data"])], 64);
    };
  }
});